import { DashboardMember } from '../../components/Dashboard';

export function Dashboard() {
  return <DashboardMember />;
}
